export default __webpack_public_path__ + "static/media/Bosta Upload Template KSA.V2.7.dd574c43.xlsx";